module.exports = dibs_vendor;